import { filterValidSizeImages } from './imageValidation';

// ヘルパー関数：画像オブジェクトからURLを取得
const getImageUrl = (image: any): string | null => {
  if (typeof image === 'string') {
    return image;
  }
  if (image && image.url) {
    return image.url;
  }
  return null;
};

// ヘルパー関数：文字列をパースして画像URLを取得
const parseStringImages = (images: string): string | null => {
  try {
    const parsed = JSON.parse(images);
    if (Array.isArray(parsed) && parsed.length > 0) {
      return getImageUrl(parsed[0]);
    }
    if (parsed && parsed.url) {
      return parsed.url;
    }
  } catch {
    // パースできない場合は単一の画像URLとして扱う
    return images;
  }
  return null;
};

// 記事の最初の画像URLを取得する関数（JSON形式の画像データ用）
export const getFirstArticleImageUrl = (images?: any): string | null => {
  if (!images) return null;

  // 文字列の場合（JSON文字列の可能性がある）
  if (typeof images === 'string') {
    return parseStringImages(images);
  }

  // JSON配列の場合
  if (Array.isArray(images) && images.length > 0) {
    return getImageUrl(images[0]);
  }

  // JSON オブジェクトの場合
  if (typeof images === 'object' && images.url) {
    return images.url;
  }

  return null;
};

// サイズフィルタリング付きで最初の有効な画像URLを取得する関数
export const getFirstValidImageUrl = async (
  images?: any,
  minWidth: number = 100,
  minHeight: number = 100
): Promise<string | null> => {
  if (!images) return null;

  let imageUrls: string[] = [];

  // 文字列の場合（JSON文字列の可能性がある）
  if (typeof images === 'string') {
    try {
      const parsed = JSON.parse(images);
      if (Array.isArray(parsed)) {
        imageUrls = parsed
          .map(img => {
            if (typeof img === 'string') return img;
            if (img && img.url) return img.url;
            return null;
          })
          .filter(Boolean);
      } else if (parsed && parsed.url) {
        imageUrls = [parsed.url];
      } else {
        imageUrls = [images]; // パースできない場合は元の文字列を使用
      }
    } catch {
      imageUrls = [images]; // パースできない場合は元の文字列を使用
    }
  }
  // JSON配列の場合
  else if (Array.isArray(images)) {
    imageUrls = images
      .map(img => {
        if (typeof img === 'string') return img;
        if (img && img.url) return img.url;
        return null;
      })
      .filter(Boolean);
  }
  // JSON オブジェクトの場合
  else if (typeof images === 'object' && images.url) {
    imageUrls = [images.url];
  }

  if (imageUrls.length === 0) return null;

  // サイズフィルタリングを適用
  const validImages = await filterValidSizeImages(imageUrls, minWidth, minHeight);
  return validImages.length > 0 ? validImages[0] : null;
};

// 全ての有効な画像URLを取得する関数
export const getAllValidImageUrls = async (
  images?: any,
  minWidth: number = 100,
  minHeight: number = 100
): Promise<string[]> => {
  if (!images) return [];

  let imageUrls: string[] = [];

  // 文字列の場合（JSON文字列の可能性がある）
  if (typeof images === 'string') {
    try {
      const parsed = JSON.parse(images);
      if (Array.isArray(parsed)) {
        imageUrls = parsed
          .map(img => {
            if (typeof img === 'string') return img;
            if (img && img.url) return img.url;
            return null;
          })
          .filter(Boolean);
      } else if (parsed && parsed.url) {
        imageUrls = [parsed.url];
      } else {
        imageUrls = [images]; // パースできない場合は元の文字列を使用
      }
    } catch {
      imageUrls = [images]; // パースできない場合は元の文字列を使用
    }
  }
  // JSON配列の場合
  else if (Array.isArray(images)) {
    imageUrls = images
      .map(img => {
        if (typeof img === 'string') return img;
        if (img && img.url) return img.url;
        return null;
      })
      .filter(Boolean);
  }
  // JSON オブジェクトの場合
  else if (typeof images === 'object' && images.url) {
    imageUrls = [images.url];
  }

  if (imageUrls.length === 0) return [];

  // サイズフィルタリングを適用
  return await filterValidSizeImages(imageUrls, minWidth, minHeight);
};
